import React, { useEffect, CSSProperties } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { BonusInfoDesc } from 'src/components/Bonus';
import Intl from "./common/Intl";

function RefillBonus61(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <InformationWrapper>
            <BonusInfoContainer>
                <BonusInfoHeadH1><Intl langKey="PROMOTIONS@RefillNewHead0" /></BonusInfoHeadH1>
                <BonusInfoDesc><Intl langKey="PROMOTIONS@RefillHeadPara" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH2><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork" /> </BonusInfoHeadH2>
                <ul>
                    <li><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork1Refill" /></li>
                    <li><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork2Refill" /></li>
                    <li><Intl langKey="PROMOTIONSWELCOME@HowDoesitWork3Refill" /></li>
                </ul>
                <table style={{ borderCollapse: 'collapse', width: '60%', color: '#fff' }}>
                    <thead>
                    <tr>
                        <th style={cellStyle}>Tier</th>
                        <th style={cellStyle}>Blue</th>
                        <th style={cellStyle}>Silver</th>
                        <th style={cellStyle}>Gold</th>
                        <th style={cellStyle}>Platinum</th>
                        <th style={cellStyle}><strong>ELITE</strong></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td style={cellStyle}>Redeposit Bonus</td>
                        <td style={cellStyle}>0%</td>
                        <td style={cellStyle}>1%</td>
                        <td style={cellStyle}>2%</td>
                        <td style={cellStyle}>3%</td>
                        <td style={cellStyle}><strong>Custom<br />made</strong></td>
                    </tr>
                    </tbody>
                </table>

               
            </BonusInfoContainer>
            
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONS@RefillNewTermsHead" /> </BonusInfoHeadH3>
                <BonusInfoDesc>
                    <ol>
                        <li><Intl langKey="PROMOTIONS@RefillNewTermsDesc1" /></li>
                        <li><Intl langKey="PROMOTIONS@RefillNewTermsDesc2" /></li>
                        <li><Intl langKey="PROMOTIONS@RefillNewTermsDesc3" /></li>
                        <li><Intl langKey="PROMOTIONS@RefillNewTermsDesc4" /></li>
                        <li><Intl langKey="PROMOTIONS@RefillNewTermsDesc5" /></li>
                        <li><Intl langKey="PROMOTIONS@RefillNewTermsDesc6" /></li>
                        <li><Intl langKey="PROMOTIONS@RefillNewTermsDesc7" /></li>
                    </ol>
                </BonusInfoDesc>
            </BonusInfoContainer>
        </InformationWrapper>
    )
}

export default withTheme(withAppContext(RefillBonus61));

// Styled Component.

const cellStyle: CSSProperties = {
    border: '1px solid #ffffff',
    padding: '8px',
    textAlign: 'center',
};
  
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 3rem;
    border:1px solid white;
    border-radius: 1px;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em 1.2em;
    backdrop-filter: brightness(0.5);

    & ul li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        -webkit-letter-spacing: 0.01em;
        -moz-letter-spacing: 0.01em;
        -ms-letter-spacing: 0.01em;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

    & span {
        display: flex;
        flex-direction: column; 
        right: 0px;
        width: auto;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        text-transform: capitalize;
        color: #FFFFFF;
        align-items: flex-end;

        @media only screen and (min-width: 1700px){
            font-size: 16px;
        }
    }
`;

const BonusInfoContainer = styled.div`
   width: 100%;
   margin: auto;

   & h6 {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #C2D2FF;
        margin: 25px 0px 20px 0px;
    }

   & h5 {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

   & ul,li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
    }
`;

const BonusInfoHeadH2 = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHeadH3 = styled.h3`
    font-style: normal;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHeadH1 = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;